export const categories = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20stylish%20white%20sneakers%20on%20a%20clean%20cream%20surface%20with%20soft%20warm%20lighting%2C%20minimal%20product%20photography%2C%20sage%20green%20background%20hint%2C%20editorial%20quality%2C%20no%20text%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-shoes&orientation=landscape",
  },
  {
    name: "Hoodies / Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20soft%20cream%20colored%20hoodie%20neatly%20folded%20on%20a%20minimal%20wooden%20surface%2C%20warm%20natural%20lighting%2C%20cozy%20lifestyle%20product%20photography%2C%20sage%20green%20textile%20background%2C%20editorial%20quality%2C%20clean%20simple%20composition&width=400&height=300&seq=cat-img-hoodies&orientation=landscape",
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20white%20t-shirt%20neatly%20laid%20flat%20on%20a%20cream%20surface%2C%20soft%20warm%20natural%20lighting%2C%20clean%20fashion%20product%20photography%2C%20sage%20green%20fabric%20accent%2C%20editorial%20style%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-tshirts&orientation=landscape",
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-honour-line",
    image: "https://readdy.ai/api/search-image?query=A%20stylish%20lightweight%20beige%20jacket%20draped%20on%20a%20minimal%20wooden%20hanger%2C%20warm%20natural%20lighting%2C%20clean%20product%20photography%2C%20cream%20and%20sage%20green%20palette%2C%20editorial%20quality%2C%20elegant%20simple%20composition&width=400&height=300&seq=cat-img-jackets&orientation=landscape",
  },
  {
    name: "Pants / Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20cream%20colored%20trousers%20on%20a%20minimal%20surface%2C%20warm%20natural%20lighting%2C%20clean%20fashion%20product%20photography%2C%20soft%20sage%20green%20background%20hint%2C%20editorial%20quality%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-pants&orientation=landscape",
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-3-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20cream%20colored%20baseball%20cap%20on%20a%20clean%20surface%2C%20warm%20natural%20lighting%2C%20lifestyle%20product%20photography%2C%20sage%20green%20background%20elements%2C%20editorial%20quality%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-headwear&orientation=landscape",
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=A%20coordinated%20cream%20and%20beige%20clothing%20set%20neatly%20arranged%20on%20a%20minimal%20surface%2C%20warm%20natural%20lighting%2C%20clean%20fashion%20product%20photography%2C%20sage%20green%20accents%2C%20editorial%20quality%2C%20elegant%20simple%20composition&width=400&height=300&seq=cat-img-sets&orientation=landscape",
  },
  {
    name: "Underwear / Underpants",
    slug: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-line",
    image: "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20soft%20cream%20colored%20cotton%20fabric%20on%20a%20minimal%20surface%2C%20warm%20natural%20lighting%2C%20clean%20textile%20product%20photography%2C%20sage%20green%20background%20hint%2C%20editorial%20quality%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-underwear&orientation=landscape",
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=A%20stylish%20cream%20colored%20sports%20jersey%20neatly%20laid%20flat%20on%20a%20minimal%20surface%2C%20warm%20natural%20lighting%2C%20clean%20athletic%20product%20photography%2C%20sage%20green%20background%2C%20editorial%20quality%2C%20simple%20composition&width=400&height=300&seq=cat-img-jersey&orientation=landscape",
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-vip-crown-line",
    image: "https://readdy.ai/api/search-image?query=A%20collection%20of%20minimal%20fashion%20accessories%20including%20a%20watch%20and%20bracelet%20on%20a%20cream%20surface%2C%20warm%20natural%20lighting%2C%20lifestyle%20product%20photography%2C%20sage%20green%20accents%2C%20editorial%20quality%2C%20elegant%20simple%20composition&width=400&height=300&seq=cat-img-accessories&orientation=landscape",
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20cream%20colored%20canvas%20tote%20bag%20on%20a%20clean%20surface%2C%20warm%20natural%20lighting%2C%20lifestyle%20product%20photography%2C%20sage%20green%20background%20elements%2C%20editorial%20quality%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-bags&orientation=landscape",
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20leather%20belt%20coiled%20on%20a%20clean%20cream%20surface%2C%20warm%20natural%20lighting%2C%20product%20photography%2C%20soft%20sage%20green%20background%2C%20editorial%20quality%2C%20simple%20elegant%20composition&width=400&height=300&seq=cat-img-belts&orientation=landscape",
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-contrast-drop-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20glass%20perfume%20bottle%20on%20a%20clean%20cream%20surface%20with%20soft%20warm%20lighting%2C%20elegant%20product%20photography%2C%20sage%20green%20background%20hint%2C%20editorial%20quality%2C%20simple%20refined%20composition&width=400&height=300&seq=cat-img-perfumes&orientation=landscape",
  },
  {
    name: "Other Stuff",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    image: "https://readdy.ai/api/search-image?query=A%20variety%20of%20minimal%20lifestyle%20products%20neatly%20arranged%20on%20a%20cream%20surface%2C%20warm%20natural%20lighting%2C%20diverse%20product%20photography%2C%20sage%20green%20accents%2C%20editorial%20quality%2C%20clean%20organized%20composition&width=400&height=300&seq=cat-img-other&orientation=landscape",
  },
];